import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.scss'],
  standalone: false,
})
export class HealthComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
